import React, { useState } from 'react';
import styles from './favouriteproductpagelikerequest.module.css';
import ProductCard from '../ProductCard';
import { useTranslation } from "react-i18next";

const FavouriteProductPageLikeRequest = ({ best_selling_products = [] }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;
    const totalPages = Math.ceil(best_selling_products.length / productsPerPage);
    const { t } = useTranslation();
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProducts = best_selling_products.slice(startIndex, startIndex + productsPerPage);

    return (
        <div className={'container-fluid mt-3vw'}>
            <div className="row">
                <div className="col-12 d-flex align-items-center justify-content-center">
                    <h2 className={styles.mt}>{t("maybe_like")}</h2>
                </div>
            </div>
            <div className="row">
                {currentProducts.map((product, idx) => (
                    <div className={'col-md-2'} key={idx}>
                        <ProductCard
                            img={product.img} 
                            product_name={product.product_name} 
                            price={product.price} 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FavouriteProductPageLikeRequest;
